import { render, staticRenderFns } from "./complex-menu-card.vue?vue&type=template&id=482f9f2a&scoped=true&"
import script from "./complex-menu-card.vue?vue&type=script&lang=ts&"
export * from "./complex-menu-card.vue?vue&type=script&lang=ts&"
import style0 from "./complex-menu-card.vue?vue&type=style&index=0&id=482f9f2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f9f2a",
  null
  
)

export default component.exports